import React from "react";
import { errorMessages } from "../constants";

export default function Error() {
  return <div className="container">{errorMessages.GENERIC}</div>;
}
